import React, { useState, useEffect } from 'react';
import { X, Sun, Moon, PlayCircle } from '@phosphor-icons/react';

// Function to apply theme class to HTML element
const applyTheme = (theme) => {
  const root = window.document.documentElement;
  root.classList.remove('light', 'dark');
  root.classList.add(theme);
  localStorage.setItem('theme', theme);
};

const SettingsModal = ({ isOpen, onClose, onStartTour }) => {
  // Get initial theme from localStorage or default to 'light'
  const [theme, setTheme] = useState(() => {
    const savedTheme = localStorage.getItem('theme');
    return savedTheme || 'light';
  });

  // Apply theme class on initial render and when theme state changes
  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  if (!isOpen) return null;

  const handleThemeChange = (newTheme) => {
    setTheme(newTheme);
  };

  return (
    <div 
      className="fixed inset-0 bg-black bg-opacity-50 z-40 flex justify-center items-center p-4" 
      onClick={onClose} // Close modal on background click
      dir="rtl" // Ensure RTL direction
    >
      <div 
        className="bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md p-6 relative text-gray-800 dark:text-gray-200" // Added dark mode background/text
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
      >
        {/* Close Button */}
        <button 
          onClick={onClose} 
          className="absolute top-3 left-3 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 p-1 rounded-full"
          aria-label="بستن تنظیمات"
        >
          <X size={20} />
        </button>

        {/* Modal Header */}
        <h2 className="text-xl font-bold mb-6 text-center">تنظیمات نمایش</h2>

        {/* --- Settings Sections Will Go Here --- */}
        <div className="space-y-6">
          {/* --- Theme Settings --- */}
          <div>
            <h3 className="text-lg font-semibold mb-3">تم برنامه</h3>
            <div className="flex justify-around items-center space-x-4 rtl:space-x-reverse">
              {/* Light Theme Button */}
              <button
                onClick={() => handleThemeChange('light')}
                className={`flex flex-col items-center justify-center p-4 rounded-lg border w-1/2 transition-colors ${ 
                  theme === 'light' 
                  ? 'bg-blue-100 border-blue-300 dark:bg-blue-900 dark:border-blue-700' 
                  : 'bg-gray-50 hover:bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 border-gray-200 dark:border-gray-600'
                }`}
              >
                <Sun size={24} className={`mb-1 ${theme === 'light' ? 'text-blue-600 dark:text-blue-400' : 'text-gray-500 dark:text-gray-400'}`} />
                <span className={`text-sm font-medium ${theme === 'light' ? 'text-blue-800 dark:text-blue-300' : 'text-gray-700 dark:text-gray-300'}`}>روشن</span>
              </button>
              {/* Dark Theme Button */}
              <button
                onClick={() => handleThemeChange('dark')}
                className={`flex flex-col items-center justify-center p-4 rounded-lg border w-1/2 transition-colors ${ 
                  theme === 'dark' 
                  ? 'bg-indigo-100 border-indigo-300 dark:bg-indigo-900 dark:border-indigo-700' 
                  : 'bg-gray-50 hover:bg-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 border-gray-200 dark:border-gray-600'
                }`}
              >
                <Moon size={24} className={`mb-1 ${theme === 'dark' ? 'text-indigo-600 dark:text-indigo-400' : 'text-gray-500 dark:text-gray-400'}`} />
                <span className={`text-sm font-medium ${theme === 'dark' ? 'text-indigo-800 dark:text-indigo-300' : 'text-gray-700 dark:text-gray-300'}`}>تیره</span>
              </button>
            </div>
          </div>

          {/* Tour Settings */}
          <div>
            <h3 className="text-lg font-semibold mb-3">تور آموزشی</h3>
            <button
              onClick={() => {
                onStartTour && onStartTour();
                onClose();
              }}
              className="flex items-center justify-center w-full p-3 bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-colors"
            >
              <PlayCircle size={20} className="ml-2" />
              <span>شروع مجدد تور آموزشی</span>
            </button>
            <p className="text-xs text-gray-500 mt-2 text-center">
              تور آموزشی به شما کمک می‌کند تا با امکانات برنامه آشنا شوید
            </p>
          </div>

          {/* Font Size Settings */}
          {/* Font Family Settings */}
        </div>
        
      </div>
    </div>
  );
};

export default SettingsModal; 